/**
 * ตัวเลือก "ค้นหาด้วย" ของช่องค้นหาคนไข้ ต้องตรงกับ enum CONDITION_SEARCH_PATIENT ฝั่ง API
 * ค่าที่อ่านจาก storage ต้องผ่านตัวนี้ก่อนส่งไป API เสมอ เพราะค่าที่ไม่รู้จัก
 * (เช่น ค่า ENC: ที่ยัง decrypt ไม่ได้) จะถูกนำไปต่อเป็น SQL ฝั่ง API แล้วพัง
 */
export const PATIENT_SEARCH_FILTERS = ['cnNumber', 'branchCnNumber', 'idCard', 'phone', 'snCode', 'email'] as const
export type PatientSearchFilter = (typeof PATIENT_SEARCH_FILTERS)[number]

export const DEFAULT_PATIENT_SEARCH_FILTER: PatientSearchFilter = 'branchCnNumber'

export function toPatientSearchFilter(value: string | null | undefined): PatientSearchFilter {
  return (PATIENT_SEARCH_FILTERS as readonly string[]).includes(value || '') ? (value as PatientSearchFilter) : DEFAULT_PATIENT_SEARCH_FILTER
}
